import { createSelector } from "@reduxjs/toolkit";
import isEmpty from "lodash/isEmpty";

export const userExists = createSelector(
  (state) => state.auth.user,
  (user) => !isEmpty(user),
);
